import SideTooltip from '../SideTooltip'

interface PillButtonProps {
	/** Иконка внутри кнопки */
	icon: React.ReactNode
	/** Текстовый лейбл рядом с иконкой (для плашек типа «Фото», «Видео») */
	label?: string
	/** Текст тултипа */
	tooltip?: string
	/** Сторона тултипа */
	tooltipSide?: 'left' | 'right' | 'auto'
	/** glass — прозрачный белый (кнопки действий), dark — тёмный (плашки типа) */
	variant?: 'glass' | 'dark'
	onClick?: (e: React.MouseEvent) => void
	className?: string
	type?: 'button' | 'submit'
	disabled?: boolean
	'aria-label'?: string
	/** Если true — рендерит <span> вместо <button> (для не-кликабельных плашек) */
	as?: 'button' | 'span'
	/** Подсказка при наведении; у плашек без текста (тип файла иконкой) — единственное слово. */
	title?: string
}

export function PillButton({
	icon,
	label,
	tooltip,
	tooltipSide = 'left',
	variant = 'glass',
	onClick,
	className = '',
	type = 'button',
	disabled,
	'aria-label': ariaLabel,
	as: Tag = 'button',
	title,
}: PillButtonProps) {
	const cls = `pill-btn pill-btn--${variant}${className ? ` ${className}` : ''}`

	const content = (
		<>
			{icon}
			{label && <span className="pill-btn__label">{label}</span>}
		</>
	)

	const element =
		Tag === 'span' ? (
			<span className={cls} title={title} aria-label={ariaLabel} role={ariaLabel ? 'img' : undefined}>{content}</span>
		) : (
			<button
				className={cls}
				onClick={onClick}
				type={type}
				disabled={disabled}
				aria-label={ariaLabel}
				title={title}
			>
				{content}
			</button>
		)

	if (tooltip) {
		return (
			<SideTooltip text={tooltip} delay={0} preferSide={tooltipSide}>
				{element}
			</SideTooltip>
		)
	}

	return element
}
